import React from 'react'
import { Modal, Form, Col, Row, Button } from 'react-bootstrap'
import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
import { useForm } from '@src/lib/react-hook-form'
import z from 'zod'
import { EmployeeDto } from '@src/domain/repositories/system.repo'

interface EditCarBrandProps {
  dtoUuid?: string;
  itemDto?: EmployeeDto;
}

const initState: EmployeeDto = {
  name: '',
  employeeNo: '',
  email: '',
  mobile: '',
  arrivalDate: '',
  status: '1'
}

export function EditEmployeeModalWrapper(props: EditCarBrandProps) {
  const { resolve, remove, hide } = useModalAction()
  const { dtoUuid, itemDto } = props
  
  const { register, handleSubmit, formState: { errors } } = useForm<EmployeeDto>({
    reValidateMode: 'onSubmit',
    defaultValues: {...initState, ...itemDto},
    rules: z.object({
      name: z.string().nonempty({ message: '請輸入姓名' }),
      employeeNo: z.string().nonempty({ message: '請輸入員工編號' }),
      email: z.string().optional(),
      mobile: z.string().optional(),
      arrivalDate: z.string().nonempty({ message: '輸入到職日' }),
      status: z.string().min(1, {message: '請選擇狀態'})
    })
  })

  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }

  const handleCancel = () => {
    resolve(ModalResolveType.CANCEL)
    hide()
    remove()
  }

  const handleOnSubmit = (formDto: EmployeeDto) => {
    resolve(ModalResolveType.OK, formDto)
    hide()
    remove()
  }

  return (
    <Modal size='lg' show onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(handleOnSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>{`${dtoUuid ? '編輯' : '新增'}員工資料`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              員工編號
            </Form.Label>
            <Col sm="10">
              <Form.Control {...register('employeeNo')} />
            </Col>
            {errors.employeeNo && <Form.Text className='text-danger'>{errors.employeeNo.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              員工姓名
            </Form.Label>
            <Col sm="10">
              <Form.Control {...register('name')} />
            </Col>
            {errors.name && <Form.Text className='text-danger'>{errors.name.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              電話
            </Form.Label>
            <Col sm="10">
              <Form.Control {...register('mobile')} />
            </Col>
            {errors.mobile && <Form.Text className='text-danger'>{errors.mobile.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Email
            </Form.Label>
            <Col sm="10">
              <Form.Control {...register('email')} />
            </Col>
            {errors.email && <Form.Text className='text-danger'>{errors.email.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              到職日
            </Form.Label>
            <Col sm="10">
              <Form.Control type='date' {...register('arrivalDate')} />
            </Col>
            {errors.arrivalDate && <Form.Text className='text-danger'>{errors.arrivalDate.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm='2'>
              狀態
            </Form.Label>
            <Col sm='10'>
              <Form.Select {...register('status')}>
                <option value='1'>啟用</option>
                <option value='0'>停用</option>
              </Form.Select>
            </Col>
            {errors.status && <Form.Text className='text-danger'>{errors.status.message}</Form.Text>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCancel} variant='light'>
            取消
          </Button>
          <Button type='submit'>
            確認
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const EditEmployeeModal = createModal(EditEmployeeModalWrapper)
